/* ML-05 · WAVES & BULK DISPLAYS
   Activation in waves, and per-establishment print files — never a generic
   multi-site QR. */
import { Button, ListRow, Pill } from '@/ui'
import { useML } from './EtabShell'

export default function ML05Vagues() {
  const waves = useML().waves
  return (
    <section data-frame="ML-05" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">Activation par vagues</h2>
      <div>
        {waves.map(w => (
          <ListRow key={w.title} title={w.title} meta={w.meta}
            end={
              w.status ? <Pill tone={w.status.tone} mark={w.status.mark}>{w.status.label}</Pill>
              : w.action ? <Button variant="primary" size="sm">{w.action}</Button>
              : undefined
            } />
        ))}
      </div>
      <div>
        <Button variant="quiet" size="sm">Télécharger tous les supports (ZIP par établissement)</Button>
      </div>
      <p className="t-body">
        Chaque fichier imprimé porte le bon établissement — jamais un QR générique multi-sites.
      </p>
    </section>
  )
}
